import React, { ReactNode } from 'react';
import classNames from 'classnames';

type Props = {
  name: string;
  label: string | ReactNode;
  value: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean, value: string | undefined) => void;
  className?: string;
};

export const StyledCheckbox: React.FC<Props> = ({
  name,
  label,
  value = '1',
  checked,
  disabled = false,
  onChange,
  className,
}) => {
  return (
    <label
      className={classNames(
        className,
        'checkbox',
        { 'checkbox--checked': checked },
        { disabled: disabled },
      )}
    >
      <span className='checkbox__input'>
        <input
          type='checkbox'
          name={name}
          value={value}
          onChange={(event) => {
            onChange(event.target.checked, event.target.checked ? value : undefined);
          }}
          checked={checked}
          disabled={disabled}
        />
        <span className='checkbox__control' />
      </span>
      {label && <span className='checkbox__label'>{label}</span>}
    </label>
  );
};
